// @flow

const ZoomLevels = {
    LEVEL_1: 720, //12 hrs
    LEVEL_2: 480, //8 hrs
    LEVEL_3: 240, //4 hrs
    LEVEL_4: 120, //2 hrs
    LEVEL_5: 90, //1.5 hrs
    LEVEL_6: 60, //1 hrs
    LEVEL_7: 30, //30 mins
    LEVEL_8: 15, //15 mins
    LEVEL_9: 5 //5 mins
};

export const ZoomInSecondsEnum = {
    LEVEL_1: ZoomLevels.LEVEL_1 * 60,
    LEVEL_2: ZoomLevels.LEVEL_2 * 60,
    LEVEL_3: ZoomLevels.LEVEL_3 * 60,
    LEVEL_4: ZoomLevels.LEVEL_4 * 60,
    LEVEL_5: ZoomLevels.LEVEL_5 * 60,
    LEVEL_6: ZoomLevels.LEVEL_6 * 60,
    LEVEL_7: ZoomLevels.LEVEL_7 * 60,
    LEVEL_8: ZoomLevels.LEVEL_8 * 60,
    LEVEL_9: ZoomLevels.LEVEL_9 * 60
};

export const ZoomInPixelsEnum = {
    LEVEL_1: ZoomLevels.LEVEL_1 * 1000,
    LEVEL_2: ZoomLevels.LEVEL_2 * 1000,
    LEVEL_3: ZoomLevels.LEVEL_3 * 1000,
    LEVEL_4: ZoomLevels.LEVEL_4 * 1000,
    LEVEL_5: ZoomLevels.LEVEL_5 * 1000,
    LEVEL_6: ZoomLevels.LEVEL_6 * 1000,
    LEVEL_7: ZoomLevels.LEVEL_7 * 1000,
    LEVEL_8: ZoomLevels.LEVEL_8 * 1000,
    LEVEL_9: ZoomLevels.LEVEL_9 * 1000
};
